<template>
	<van-popup v-model="visible" :close-on-click-overlay="true">
	  <div class="unfollowPop">
		<div class="title">取消关注</div>
		<div class="desc">确定要取消关注吗?</div>
		<div class="bott">
		  <single-button 
			text="确定" 
			background="transparent" 
			width="6.5rem"
			height="2rem"
			radius="1rem"
			border="0.05rem solid #8E703A" 
			color="#C1A673" 
			@know="$emit('confirm')" 
			class="btn">
		  </single-button>
		  <single-button 
			text="再想想" 
			width="6.5rem"
			height="2rem"
			radius="1rem"
			border="0.05rem solid #8E703A"
			@know="handleClose" 
			color="#FFF">
		  </single-button>
		</div>
	  </div>
	</van-popup>
  </template>
  
  <script>
  export default {
	name: 'UnfollowPop',

	data() {
	  return {
		visible: false
	  }
	},
	
	methods: {
	  handleClose() {
		this.visible = false;
	  },
	  open() {
		this.visible = true;
	  }
	}
  }
  </script>
  
  <style scoped lang="scss">
  .btn {
	text-align: center !important;
	line-height: 2rem !important;
  }
  
  .unfollowPop {
	padding: 1.5rem 1.25rem;
	line-height: normal;
	text-align: center;
	width: 17rem;
	background: #F8F3E9;
	border-radius: 1.5rem;
	border: 0.05rem solid #EEE6E6;
	box-sizing: border-box;
  
	.title {
	  font-weight: bold;
	  color: #000000;
	  font-size: 1rem;
	  margin-bottom: 1rem;
	}
  
	.desc {
	  color: #000000;
	  font-size: 0.7rem;
	  margin-bottom: 1.5rem;
	}
  
	.bott {
	  display: flex;
	  justify-content: space-between;
	}
  }
  </style>